import { AcceptedFileExtension } from './constants';

export const getAcceptDescription = (accept: AcceptedFileExtension[]) => {
  if (!accept || accept.length === 0) return 'file';

  // Map extensions and MIME groups to clean readable names
  const readableList = accept.map(type => {
    if (type.endsWith('/*')) {
      // handle generic mime groups like image/*, audio/*, video/*
      return type.replace('/*', '');
    }

    if (type.startsWith('.')) {
      // handle file extensions
      return type;
    }

    // fallback for any unexpected accept format
    return type.split('/')[0];
  });

  const readable = readableList.join(', ');
  const first = readable[0]?.toLowerCase() || '';
  const article = ['a', 'e', 'i', 'o', 'u'].includes(first) ? 'an' : 'a';
  const plural = readableList.length > 1 ? 'files' : 'file';

  return `${article} ${readable} ${plural}`;
};
